<template>
  <div class="page-container">
    <div class="header-banner">
      <img src="@/assets/newImage/inviterHeader.png" alt="邀请好友注册" />
    </div>
    <div class="content-container">
      <!-- 邀请方式 -->
      <div class="section-card">
        <div class="section-title">
          <div class="title-tag">邀请方式</div>
        </div>
        <div class="invite-methods">
          <!-- 两种邀请方式 -->
          <div class="methods-container">
            <div class="method-card bg-pink">
              <div class="method-title bg-red">扫码注册</div>
              <!-- 未登录 -->
              <div
                class="method-qrcode"
                v-if="!userInfo"
                style="
                  background-color: white;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 20px;
                "
              >
                请先登录才能发展邀请好友
              </div>
              <!-- 高级认证 -->
              <div
                class="method-qrcode"
                v-else-if="userInfo.level >= 2"
                style="width: 170px; height: 170px"
              >
                <vue-qr :text="qrCodeValue" :size="170"></vue-qr>
              </div>
              <!-- 未认证或者初级认证 -->
              <div
                class="method-qrcode"
                v-else-if="userInfo.credentialLevel < 2"
                style="
                  background-color: white;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 20px;
                "
              >
                请先认证才能发展邀请好友
              </div>
              <!-- 完成认证累计核销不够2000 -->
              <div
                class="method-qrcode"
                v-else-if="
                  userInfo.credentialLevel == 2 &&
                  userInfo.totalFaceValue < 2000
                "
                style="
                  background-color: white;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 20px;
                "
              >
              请先销卡才能发展邀请好友
              </div>

              <div style="color: blue; margin-top: 10px">
                邀请好友扫码二维码
              </div>
            </div>
            <div style="width: 74px"></div>
            <div class="method-card bg-blue-light">
              <div class="method-title bg-blue">专属链接</div>
              <!-- 未登录 -->
              <div
                class="method-qrcode"
                v-if="!userInfo"
                style="
                  background-color: white;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 20px;
                "
              >
                暂无邀请链接，请登录后获取链接
              </div>
              <!-- 高级认证 -->
              <div
                class="method-qrcode"
                v-else-if="userInfo.level >= 2"
                style="
                  width: 170px;
                  height: 170px;
                  background-color: white;
                  display: flex;
                  align-items: center;
                  overflow: hidden;
                "
              >
                <div style="font-size: 13px">{{ qrCodeValue }}</div>
              </div>
              <!-- 未认证或者初级认证 -->
              <div
                class="method-qrcode"
                v-else-if="userInfo.credentialLevel < 2"
                style="
                  background-color: white;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 20px;
                "
              >
                暂无邀请链接认证后获取链接
              </div>
              <!-- 完成认证累计核销不够2000 -->
              <div
                class="method-qrcode"
                v-else-if="
                  userInfo.credentialLevel == 2 &&
                  userInfo.totalFaceValue < 2000
                "
                style="
                  background-color: white;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 20px;
                "
              >
              请先销卡才能发展邀请好友
              </div>

              <div style="color: blue; margin-top: 10px">
                把我的专属链接发给好友
              </div>
            </div>
          </div>
          <!-- 按钮相关 -->
          <div class="auth-button" v-if="!userInfo" @click="goLogin">
            去登录
          </div>

          <div
            class="auth-button"
            v-else-if="userInfo.credentialLevel < 2"
            @click="goAuth"
          >
            去认证
          </div>
          <div
            class="auth-button"
            v-else-if="
              userInfo.credentialLevel == 2 && userInfo.totalFaceValue < 2000
            "
            @click="goSales"
          >
            去销卡
          </div>
          <div class="auth-note" v-if="!userInfo">
            请先登录，才能有机会获得邀请好友的资格，才会有专属邀请链接
          </div>
          <div class="auth-note" v-else-if="userInfo.credentialLevel != 2">
            用户需完成高级认证并累计成功销卡额度2000元
            后可开启邀请功能并升级为银牌组长
          </div>
        </div>
      </div>

      <!-- 推广员升级条件 -->
      <div class="section-card">
        <div class="section-title">
          <div class="title-tag">推广员升级条件</div>
        </div>
        <div class="promotion-conditions">
          <div class="conditions-table">
            <div class="table-header">
              <div class="header-cell left-radius">推广员级别</div>
              <div class="header-cell bg-light">升级条件A</div>
              <div class="header-cell bg-light right-radius">升级条件B</div>
            </div>

            <!-- 钻石精英 -->
            <div class="table-row">
              <div class="level-cell">
                <img src="@/assets/newImage/编组 19备份 3@2x.png" alt="钻石" />
                <span>钻石精英</span>
              </div>
              <div class="condition-cell">20个有效下级</div>
              <div class="condition-cell">
                所有下级销卡金额度累计40000元以上
              </div>
            </div>

            <!-- 金牌团长 -->
            <div class="table-row">
              <div class="level-cell">
                <img
                  src="@/assets/newImage/个人中心-银牌k备份 4@2x.png"
                  alt="金牌"
                />
                <span>金牌团长</span>
              </div>
              <div class="condition-cell">5个有效下级</div>
              <div class="condition-cell">
                所有下级销卡金额度累计10000元以上
              </div>
            </div>

            <!-- 银牌组长 -->
            <div class="table-row">
              <div class="level-cell">
                <img
                  src="@/assets/newImage/个人中心-银牌k备份 7@2x.png"
                  alt="银牌"
                />
                <span>银牌组长</span>
              </div>
              <div class="condition-cell">完成高级认证</div>
              <div class="condition-cell">累计核销2000元以上</div>
            </div>

            <!-- 普通用户 -->
            <div class="table-row">
              <div class="level-cell">
                <img
                  src="@/assets/newImage/个人中心-银牌k备份@2x.png"
                  alt="普通"
                />
                <span>普通用户</span>
              </div>
              <div class="condition-cell">注册默认</div>
              <div class="condition-cell">注册默认</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 奖励 -->
      <div class="section-card">
        <div class="section-title">
          <div class="title-tag">奖励</div>
        </div>
        <div class="rewards-container">
          <!-- 银牌奖励 -->
          <div class="reward-card">
            <div class="reward-tag">银牌</div>
            <div class="reward-text">
              邀请用户核销实际面值<span class="text-blue">*0.1%</span>
            </div>
          </div>

          <!-- 金牌奖励 -->
          <div class="reward-card">
            <div class="reward-tag">金牌</div>
            <div class="reward-text">
              邀请用户核销实际面值<span class="text-blue">*0.15%</span><br />
              银牌升级金牌奖励增加<span class="text-blue">50%</span>
            </div>
          </div>

          <!-- 钻石奖励 -->
          <div class="reward-card">
            <div class="reward-tag">钻石</div>
            <div class="reward-text">
              邀请用户核销实际面值<span class="text-blue">*0.3%</span><br />
              金牌升级钻石奖励增加<span class="text-blue">100%</span>
            </div>
          </div>

          <!-- 示例部分 -->
          <div class="example-section">
            <div class="example-card">
              <div class="example-header">
                <div class="title">例如：</div>
                <div class="divider"></div>
              </div>

              <div class="example-content">
                <!-- 银牌示例 -->
                <div class="example-item">
                  <p>
                    用户小慧等级为银牌组长，她邀请的用户核销<span
                      class="text-blue"
                      >1000</span
                    >元京东E卡
                  </p>
                  <p>
                    小慧可得到的奖励为<span class="text-blue"
                      >1000 * 0.1%=1</span
                    ><span class="text-gray">(元)</span>
                  </p>
                </div>

                <!-- 金牌示例 -->
                <div class="example-item">
                  <p>
                    用户小慧等级为金牌组长，她邀请的用户核销<span
                      class="text-blue"
                      >1000</span
                    >元京东E卡
                  </p>
                  <p>
                    小慧可得到的奖励为<span class="text-blue"
                      >1000 * 0.15%=1.5</span
                    ><span class="text-gray">(元)</span>
                  </p>
                </div>

                <!-- 钻石示例 -->
                <div class="example-item">
                  <p>
                    用户小慧等级为钻石精英，她邀请的用户核销<span
                      class="text-blue"
                      >1000</span
                    >元京东E卡
                  </p>
                  <p>
                    小慧可得到的奖励为<span class="text-blue"
                      >1000 * 0.3%=3</span
                    ><span class="text-gray">(元)</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 活动规则 -->
      <div class="section-card">
        <div class="section-title">
          <div class="title-tag">活动规则</div>
        </div>
        <div class="rules-container">
          <ol class="rule-list">
            <li>
              1:为保障用户已邀请的好友不会流失或者后面变成自己邀请自己，我们开通邀请功能、销卡、提现都需要通过实名认证，而且一个身份证只能实名认证一个帐号，可以有效保障用户邀请好友的权益；
            </li>
            <li>
              2:邀请按注册原则，比如好友先访问A用户的邀请链接，又访问B用户的邀请链接，最终在B用户的链接上注册了,那他就算B用户邀请的；
            </li>
            <li>3:实际返现佣金比例可能会有小范围波动，具体以实际返现为准。</li>
            <li>4:另若发现邀请人恶意刷佣金，一经查实将禁用帐号。</li>
            <li>5:如有疑问请联系在线客服。</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/utils/http/axios";
import vueQr from "vue-qr";
export default {
  name: "InviterView",
  components: {
    vueQr,
  },
  data() {
    return {
      userInfo: undefined,
      qrCodeValue: "",
      state: 0,
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    goLogin() {
      this.$router.push("/login");
    },
    goAuth() {
      this.$store.commit("changedUserId", 6);
      this.$store.commit("changedUserChildId", 5.4);
      this.$router.push("/user");
      this.$bus.$emit("changedTab", 100086);
    },
    goSales(){
      this.$bus.$emit("changedTab", 1);
      this.$router.push("/sales");

    },
    // 获取用户信息
    getUserInfo() {
      http
        .get("/user/base/info")
        .then((response) => {
          if (response.code === 200) {
            this.userInfo = response.data;
            this.qrCodeValue =
              "https://register.huishouka.com.cn/?inviteCode=" + response.data.userId;
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="less" scoped>
.page-container {
  background-color: #d5effe;
  width: 100%;
  overflow-x: hidden;

  .header-banner {
    height: 375px;
    width: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .content-container {
    padding: 0 103px;
    display: flex;
    flex-direction: column;

    // 公共卡片样式
    .section-card {
      display: flex;
      flex-direction: column;
      background-color: white;
      border-radius: 32px;
      width: 100%;
      position: relative;
      margin-top: 81px;
      padding-bottom: 40px;

      // 标题样式
      .section-title {
        position: absolute;
        left: 0;
        right: 0;
        top: -46px;
        height: 93px;
        display: flex;
        align-items: center;
        justify-content: center;

        .title-tag {
          width: 366px;
          height: 93px;
          background: linear-gradient(180deg, #ffcf18 0%, #ff8f0a 100%);
          border-radius: 37px;
          line-height: 93px;
          text-align: center;
          font-size: 42px;
          color: #ffffff;
          font-weight: 600;
        }
      }

      // 邀请方式区域
      .invite-methods {
        margin: 98px 84px 42px;
        display: flex;
        flex-direction: column;

        .methods-container {
          height: 363px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .method-card {
            flex: 1;
            height: 100%;
            border-radius: 54px;
            display: flex;
            flex-direction: column;
            align-items: center;

            &.bg-pink {
              background: #ffe1e1;
            }

            &.bg-blue-light {
              background: #d1f4fd;
            }

            .method-title {
              margin-top: 39px;
              width: 274px;
              height: 60px;
              border-radius: 30px;
              line-height: 60px;
              text-align: center;
              color: white;
              font-size: 30px;

              &.bg-red {
                background: linear-gradient(180deg, #ff5e5e 0%, #ff4b4b 100%);
              }

              &.bg-blue {
                background: linear-gradient(180deg, #7ed4ff 0%, #0c9aff 100%);
              }
            }

            .method-qrcode {
              margin-top: 30px;
              text-align: center;
              background: #d8d8d8;
              border-radius: 5px;
            }
          }
        }

        .auth-button {
          width: 738px;
          height: 106px;
          background: #487aff;
          border-radius: 85px;
          margin: 52px auto 0;
          font-size: 38px;
          line-height: 106px;
          text-align: center;
          color: #ffffff;
        }

        .auth-note {
          width: 1090px;
          height: 59px;
          background: #fff0d3;
          line-height: 59px;
          text-align: center;
          font-size: 28px;
          color: #f97030;
          margin: 20px auto 0;
        }
      }

      // 推广员升级条件区域
      .promotion-conditions {
        height: 849px;
        display: flex;
        justify-content: center;
        align-items: center;

        .conditions-table {
          width: 898px;
          background: #ffffff;
          border-radius: 15px;
          border: 2px solid #ff9d0d;

          .table-header {
            display: flex;

            .header-cell {
              flex: 1;
              height: 95px;
              background: #fdd182;
              line-height: 95px;
              text-align: center;
              font-size: 32px;
              color: #e6540a;

              &.left-radius {
                border-top-left-radius: 15px;
              }

              &.right-radius {
                border-top-right-radius: 15px;
              }

              &.bg-light {
                background-color: #fef5f2;
              }
            }
          }

          .table-row {
            height: 85px;
            display: flex;
            align-items: center;
            font-size: 28px;
            color: #000000;
            margin-top: 50px;

            .level-cell,
            .condition-cell {
              flex: 1;
              text-align: center;
              line-height: 40px;
            }

            .level-cell {
              display: flex;
              align-items: center;
              justify-content: center;

              img {
                width: 56px;
                height: 61px;
              }

              span {
                margin-left: 34px;
              }
            }
          }
        }
      }

      // 奖励区域
      .rewards-container {
        padding: 60px 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        .reward-card {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 30px;
          width: 80%;

          .reward-tag {
            width: 122px;
            height: 60px;
            background: #facf41;
            border-radius: 16px;
            line-height: 60px;
            text-align: center;
            color: rgba(0, 0, 0, 0.9);
            font-size: 36px;
            font-weight: 600;
            flex-shrink: 0;
          }

          .reward-text {
            margin-left: 45px;
            line-height: 40px;
            font-size: 28px;
          }
        }

        .example-section {
          margin-top: 40px;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;

          .example-card {
            // width: 80%;
            // border-radius: 16px;
            padding: 25px 30px;
            position: relative;
            border: 1px solid rgba(255, 170, 15, 0.3);

            .example-header {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              margin-bottom: 15px;

              .title {
                font-size: 32px;
                color: rgba(0, 0, 0, 0.9);
                font-weight: 500;
                margin: 0;
              }

              .divider {
                width: 29px;
                height: 11px;
                background: #ffaa0f;
                margin-top: 5px;
              }
            }

            .example-content {
              .example-item {
                margin-bottom: 20px;
                font-size: 26px;
                line-height: 40px;
                color: rgba(0, 0, 0, 0.9);

                &:last-child {
                  margin-bottom: 0;
                }

                p {
                  margin: 5px 0;
                }
              }
            }
          }
        }
      }

      // 活动规则区域
      .rules-container {
        padding: 60px 300px 30px;

        .rule-list {
          font-size: 30px;

          color: rgba(0, 0, 0, 0.9);
          padding-left: 20px;

          li {
            line-height: 55px;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}

// 公共颜色样式
.text-blue {
  color: #4d7ef4;
}

.text-gray {
  color: #666;
}
</style>